"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkForRenderAnchorTag = void 0;
const checkForRenderAnchorTag = (url, linkComponent) => {
  if (!linkComponent) {
    return true;
  } else if (url && url.length >= 4 && url.substring(0, 4) === "http") {
    return true;
  } else {
    return false;
  }
};
exports.checkForRenderAnchorTag = checkForRenderAnchorTag;